
import React from "react";
import { PartFilter } from "@/data/parts";
import RequirementItem from "./RequirementItem";
import { getRequirementItemConfig } from "./RequirementItemData";

interface RequirementsListProps {
  requiresRoot: boolean;
  requiresWiring?: boolean;
  requiresPrinting?: boolean;
  requiresTools?: boolean;
  requiresPurchase?: boolean;
  printedParts?: string;
  hasShoppingLinks: boolean;
  subcategory: string;
  activeFilters: PartFilter[];
  activeBadge: PartFilter | null;
  onFilterToggle: (filter: PartFilter) => void;
}

const RequirementsList = ({
  requiresRoot,
  requiresWiring = false,
  requiresPrinting = false,
  requiresTools = false,
  requiresPurchase = false,
  printedParts,
  hasShoppingLinks,
  subcategory,
  activeFilters,
  activeBadge,
  onFilterToggle
}: RequirementsListProps) => {
  // Get configurations for all requirement items
  const requirementItems = getRequirementItemConfig(
    requiresRoot,
    requiresWiring,
    requiresPrinting,
    requiresTools,
    requiresPurchase,
    printedParts,
    hasShoppingLinks,
    subcategory
  );
  
  // Check if a filter is active
  const isFilterActive = (filter: PartFilter): boolean => {
    return activeFilters.includes(filter);
  };

  // Define the specific order for the requirement items
  const orderedKeys = ["root", "tools", "wiring", "printing", "purchase"];

  return (
    <div className="flex flex-col space-y-2">
      {orderedKeys.map((key) => (
        requirementItems[key] && (
          <RequirementItem
            key={key}
            config={requirementItems[key]}
            isFilterActive={isFilterActive(requirementItems[key].filter)}
            onFilterToggle={onFilterToggle}
            isActiveBadge={activeBadge === requirementItems[key].filter}
          />
        )
      ))}
    </div>
  );
};

export default RequirementsList;
